import { createReducer } from '@reduxjs/toolkit'
import * as fixationsActions from '../actions/fixations'
import { APIData, APIStatus } from '../axiosConfiguration'
import {
  FixationAlloyManagementItem,
  FixationsAllRequestsData,
  FixationsManagementData,
  UserCompaniesManagementItem,
  UserCustomersManagementItem,
  UserSaleLineManagementItem,
} from '../type/fixations'
import * as usersActions from '../actions/users'

type fixationsManageState = {
  fixations: APIData<FixationsManagementData>,
  userCompanies: APIData<UserCompaniesManagementItem[]>,
  userCustomers: APIData<UserCustomersManagementItem[]>,
  userSaleLine: APIData<UserSaleLineManagementItem[]>,
  fixationAlloy: APIData<FixationAlloyManagementItem[]>,
  sendNewFixationStatus: APIStatus,
  allRequests: APIData<FixationsAllRequestsData>,
}

const initialState: fixationsManageState = {
  fixations: { status: APIStatus.IDLE },
  userCompanies: { status: APIStatus.IDLE },
  userCustomers: { status: APIStatus.IDLE },
  userSaleLine: { status: APIStatus.IDLE },
  fixationAlloy: { status: APIStatus.IDLE },
  allRequests: { status: APIStatus.IDLE },
  sendNewFixationStatus: APIStatus.IDLE,
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(fixationsActions.getFixations.fulfilled, (state, action) => {
      state.fixations.status = APIStatus.FULFILLED
      state.fixations.data = action.payload
    })
    .addCase(fixationsActions.getFixations.rejected, (state, action) => {
      state.fixations.status = APIStatus.REJECTED
      state.fixations.error = action.payload
    })
    .addCase(fixationsActions.getFixations.pending, (state) => {
      state.fixations.status = APIStatus.PENDING
    })

  builder
    .addCase(fixationsActions.getUserCompanies.fulfilled, (state, action) => {
      state.userCompanies.status = APIStatus.FULFILLED
      state.userCompanies.data = action.payload
    })
    .addCase(fixationsActions.getUserCompanies.rejected, (state, action) => {
      state.userCompanies.status = APIStatus.REJECTED
      state.userCompanies.error = action.payload
    })
    .addCase(fixationsActions.getUserCompanies.pending, (state) => {
      state.userCompanies.status = APIStatus.PENDING
    })

  builder
    .addCase(fixationsActions.getUserCustomers.fulfilled, (state, action) => {
      state.userCustomers.status = APIStatus.FULFILLED
      state.userCustomers.data = action.payload
    })
    .addCase(fixationsActions.getUserCustomers.rejected, (state, action) => {
      state.userCustomers.status = APIStatus.REJECTED
      state.userCustomers.error = action.payload
    })
    .addCase(fixationsActions.getUserCustomers.pending, (state) => {
      state.userCustomers.status = APIStatus.PENDING
    })

  builder
    .addCase(fixationsActions.getUserSaleLine.fulfilled, (state, action) => {
      state.userSaleLine.status = APIStatus.FULFILLED
      state.userSaleLine.data = action.payload
    })
    .addCase(fixationsActions.getUserSaleLine.rejected, (state, action) => {
      state.userSaleLine.status = APIStatus.REJECTED
      state.userSaleLine.error = action.payload
    })
    .addCase(fixationsActions.getUserSaleLine.pending, (state) => {
      state.userSaleLine.status = APIStatus.PENDING
    })

  builder
    .addCase(fixationsActions.getFixationAlloy.fulfilled, (state, action) => {
      state.fixationAlloy.status = APIStatus.FULFILLED
      state.fixationAlloy.data = action.payload
    })
    .addCase(fixationsActions.getFixationAlloy.rejected, (state, action) => {
      state.fixationAlloy.status = APIStatus.REJECTED
      state.fixationAlloy.error = action.payload
    })
    .addCase(fixationsActions.getFixationAlloy.pending, (state) => {
      state.fixationAlloy.status = APIStatus.PENDING
    })

  builder
    .addCase(fixationsActions.sendNewFixation.pending, (state) => {
      state.sendNewFixationStatus = APIStatus.PENDING
    })
    .addCase(fixationsActions.sendNewFixation.fulfilled, (state) => {
      state.sendNewFixationStatus = APIStatus.FULFILLED
    })
    .addCase(fixationsActions.sendNewFixation.rejected, (state) => {
      state.sendNewFixationStatus = APIStatus.REJECTED
    })
    .addCase(fixationsActions.clearNewFixation, (state) => {
      state.sendNewFixationStatus = APIStatus.IDLE
    })

  builder
    .addCase(fixationsActions.getFixationsRequests.fulfilled, (state, action) => {
      state.allRequests.status = APIStatus.FULFILLED
      state.allRequests.data = action.payload
    })
    .addCase(fixationsActions.getFixationsRequests.rejected, (state, action) => {
      state.allRequests.status = APIStatus.REJECTED
      state.allRequests.error = action.payload
    })
    .addCase(fixationsActions.getFixationsRequests.pending, (state) => {
      state.allRequests.status = APIStatus.PENDING
    })
})
